import o from "moment";
function r(e = 0, n = 0) {
  const t = o();
  return t.clone().add(e, "hour").add(n, "minute").diff(t, "minute");
}
export {
  r as default
};
